// extracted by mini-css-extract-plugin
module.exports = {"root":"_059a6d","page":"_98b0bc","pageSelector":"_830607","selected":"_e34c51"};